import axios from 'axios'
import config from 'config'
import { contains } from 'ramda'
import { removeAllTokens } from 'services/tokenService'
import { redirectToLoginPage } from '@driftt/web-auth'
import HttpStatusCodes from 'http-status-codes'

const AUTH_REDIRECT_CODES = [
  HttpStatusCodes.FORBIDDEN,
  HttpStatusCodes.UNAUTHORIZED
]

const isAuthRedirectCode = (code) => contains(code, AUTH_REDIRECT_CODES)

const successInterceptor = (response) => response

const authInterceptor = (error) => {
  if (isAuthRedirectCode(error.response.status)) {
    removeAllTokens()
    return redirectToLoginPage(config.AUTH_CLIENT_ID)
  }

  return Promise.reject(error);
}

export const createAxiosInstance = (config) => {
  const axiosInstance = axios.create(config)
  axiosInstance.interceptors.response.use(successInterceptor, authInterceptor)
  return axiosInstance
}
